// The area someone searched in is one choice across both searches: pick
// Eindhoven with a 50 km radius on /aanbod and /projecten opens on that same
// area. The two pages keep their own storage for everything else, because
// their filters have nothing in common.
//
// The radius travels with the place rather than staying per page: leaving it
// on 50 and finding 25 back on the other page reads as the site changing the
// search behind your back. The projects default of 25 km (WHN-2102) is what a
// fresh search there still starts on, and what clearing the place returns to.

const STORAGE_KEY = 'whoon.location';

export const readSharedLocation = () => {
  try {
    const stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
    if (!stored || typeof stored.loc !== 'string' || stored.loc === '') return null;
    if (!Number.isFinite(stored.long) || !Number.isFinite(stored.lat)) return null;

    const location = { loc: stored.loc, long: stored.long, lat: stored.lat };

    // null is a radius of its own ("search the whole country"), so it is kept;
    // anything else unusable leaves the page on its own default.
    if (stored.radius === null || Number.isFinite(stored.radius)) location.radius = stored.radius;

    return location;
  } catch {
    return null;
  }
};

// A place without coordinates filters nothing (see apiParams), so only a
// committed place is stored. Clearing one drops the record, so the place stops
// travelling; a page that already persisted a search of its own keeps that -
// clearing here says "show me everything here", not "forget my other search".
export const writeSharedLocation = ({ loc, long, lat, radius }) => {
  try {
    if (!loc || !Number.isFinite(long) || !Number.isFinite(lat)) {
      window.localStorage.removeItem(STORAGE_KEY);

      return;
    }

    window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ loc, long, lat, radius }));
  } catch {
    /* localStorage unavailable: the location simply does not travel */
  }
};
